import { FlyoutMixin, Mixin, MixinRef, useMixinRef } from 'brew-js-react';
import { classNames, useObservableProperty } from 'zeta-dom-react';
import { Button } from '../controls';
import { Icon } from './Icon';
import { useTranslation } from 'src/i18n';
import { useBreakpoint } from 'src/util/cssUtil';
import { useEffect } from 'react';
import { app } from "src/core/app";
import { getExternalUrl } from 'src/api/implementation/helper';
import { Language } from 'src/core/constants';
import { LangCode } from "src/api/implementation/client";
import { openWindow } from 'src/util/common';

export function Disclaimer(props: { mixinRef: MixinRef<FlyoutMixin>, url: string }) {
    const flyoutMixin = useMixinRef(props.mixinRef);
    const { t } = useTranslation('departments');
    const { isMobile } = useBreakpoint();
    const isFlyoutOpened = useObservableProperty(flyoutMixin, 'isFlyoutOpened');

    function getLangCode(lang = app.language) {
        return LangCode[lang as Language];
    }
    const lang = getLangCode();
    const BCIUrl = getExternalUrl(props.url, lang);

    useEffect(() => {
        return flyoutMixin.onToggleState(v => app.mainOverlayOpened = v);
    }, [flyoutMixin]);

    return (
        <>
            {isMobile &&
                <span className={classNames('eac-departments-blue-cross-background', { dimmed: isFlyoutOpened })}></span>}
            <div id="eac-departments-blue-cross" {...Mixin.use(flyoutMixin.withEffects('fade-in'))}>
                <h1>{t('BCI.title')}</h1>
                <p>{t('BCI.content1')}</p>
                <p>{t('BCI.content2')}</p>
                <div className="eac-disclaimer-button">
                    <Button label={t('BCI.button.accept')} variant="primary" data-testid="disclaimer-flyout-accept" onClick={() => {
                        flyoutMixin.close();
                        setTimeout(() => {
                            openWindow(BCIUrl);
                        });
                    }}></Button>
                    <Button label={t('BCI.button.decline')} variant="outlined" data-testid="disclaimer-flyout-decline" onClick={() => flyoutMixin.close()}></Button>
                </div>
                <div className='eac-flyout-close' data-testid="disclaimer-flyout-close" onClick={() => flyoutMixin.close()}>
                    <Icon icon="close" />
                </div>
            </div>
        </>
    );
}